import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ListItemText, Menu, MenuItem } from "@mui/material";
import { CheckIcon } from "conference/components/icons";
import { useSelfVideoDialogSettings } from "./context";
import { useVideoEffectManager } from "../../contexts/videoEffectContext";
import { useBoolState } from "@dvrt/react-tools";
import VideoBackgroundEffectDialog from "../../video-background-effect-dialog/VideoBackgroundEffectDialog";
import { DenseListItemIcon } from "conference/components/widgets";
import { MenuButton as MenuButtonBase } from "./tools";
import { FormattedMessage } from "react-intl";
import { useState } from "react";

const MenuButton = ({ onResetAr }: { onResetAr?: () => void }) => {
    const [anchorEl, setAnchorEl] = useState<HTMLElement>(null);
    const settings = useSelfVideoDialogSettings();
    const { available } = useVideoEffectManager();
    const [isShowBED, showBED, hideBED] = useBoolState();

    const close = () => setAnchorEl(null);

    return (
        <>
            <MenuButtonBase onClick={(ev) => setAnchorEl(ev.currentTarget)}>
                <FontAwesomeIcon
                    icon="ellipsis-h"
                    style={{ margin: "-2px 0", filter: "drop-shadow(0px 0px 2px black)" }}
                />
            </MenuButtonBase>
            <VideoBackgroundEffectDialog show={isShowBED} close={hideBED} />
            <Menu open={!!anchorEl} anchorEl={anchorEl} onClose={close}>
                <MenuItem
                    dense
                    onClick={() => {
                        onResetAr();
                        close();
                    }}
                    style={{ display: onResetAr ? "flex" : "none" }}
                >
                    <DenseListItemIcon />
                    <ListItemText
                        primary={<FormattedMessage id="selfVideoMenu.resetAr" defaultMessage="Reset aspect ratio" />}
                    />
                </MenuItem>
                <MenuItem
                    dense
                    onClick={() => {
                        settings.alwaysFloat = !settings.alwaysFloat;
                        close();
                    }}
                >
                    <DenseListItemIcon>{settings.alwaysFloat && <CheckIcon />}</DenseListItemIcon>
                    <ListItemText
                        primary={<FormattedMessage id="selfVideoMenu.alwaysFloat" defaultMessage="Always float" />}
                    />
                </MenuItem>
                {available && (
                    <MenuItem
                        dense
                        onClick={() => {
                            showBED();
                            close();
                        }}
                    >
                        <DenseListItemIcon />
                        <ListItemText
                            primary={
                                <FormattedMessage
                                    id="selfVideoMenu.changeBackground"
                                    defaultMessage="Change background"
                                />
                            }
                        />
                    </MenuItem>
                )}
            </Menu>
        </>
    );
};

export default MenuButton;
